import { isKnownMetric } from '@blisspointmedia/bpm-types/dist/Metrics';

export type ServerValueMap = Partial<Record<string, number | string | null>>;

// SQL values from `/getChannelMetricsTableData` (`includeMetrics` / `includeTotals`). Totals are
// keyed by fetch key; `otherTotals` comes from the comparison-period request.
export interface ServerMetricValues {
  totals?: Record<string, ServerValueMap>;
  otherTotals?: Record<string, ServerValueMap>;
}

// A custom column named like a registry metric (e.g. a custom `cpx`) is dropped by the server's
// custom-metric compiler, so the server value under that name is the REGISTRY metric.
export const isServerValueUsable = (
  meta: { isCustom?: boolean } | undefined,
  rootName: string
): boolean => !(meta?.isCustom && isKnownMetric(rootName));

// Presence, not `??`: a server null (e.g. no performance rows for the KPI) is a real value.
export const readServerValue = (
  values: ServerValueMap | Record<string, unknown> | undefined,
  key: string
): { found: boolean; value: number | null } => {
  if (!values || !Object.hasOwn(values, key)) {
    return { found: false, value: null };
  }
  const num = Number(values[key]);
  return { found: true, value: values[key] === null || !Number.isFinite(num) ? null : num };
};
